import { render, staticRenderFns } from "./GradeTable.vue?vue&type=template&id=68edff6a&scoped=true"
import script from "./GradeTable.vue?vue&type=script&lang=ts"
export * from "./GradeTable.vue?vue&type=script&lang=ts"
import style0 from "./GradeTable.vue?vue&type=style&index=0&id=68edff6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68edff6a",
  null
  
)

export default component.exports